"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Globe = {
    name: 'Globe',
    suppressMirroring: true,
    tooltipKey: 'Globe.icon.label',
    render: function (props, svgRef) {
        return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: ['Globe', props.className].join(' '), width: "14", height: "14", x: "0", y: "0", version: "1.1", viewBox: "0 0 14 14", xmlSpace: "preserve", ref: svgRef }, props),
            props.tooltip && react_1.default.createElement("title", null, props.tooltip),
            react_1.default.createElement("path", { className: "svgToolTipPane", fill: "none", d: "M0 0h14v14H0z" }),
            react_1.default.createElement("path", { className: "iconColor", d: "M7 0a7 7 0 100 14A7 7 0 007 0zM1 7c0-.304.03-.6.074-.892.069.265.093.553.093.684 0 .25 1.208.583 1.25.875.042.292 0 1.083-.083 1.5-.083.417 1.75 1.417 2 1.875.161.295.218.984.238 1.44A6.006 6.006 0 011 7zm6 6c-.53 0-1.041-.076-1.53-.205.302-.558.909-1.664 1.155-2.003.333-.458 1.5-2 .875-2.792-.594-.753-1.75-1.25-2.708-1.291C3.833 6.667 3.125 7 3.125 7v-.583l-.958-.625h.958s.375-.542.75-1.042 1.083-.667 2.083-1.375c.785-.556.263-1.669-.079-2.267A6.095 6.095 0 017 1c.253 0 .501.021.746.052-.175.198-.33.407-.33.532 0 .292.917.5 1.208.708.292.208-.667.625-.5 1s1.707.174 2.042 0c.958-.5 1.958 1.5.125.667-.457-.208-1.042 0-1.417.083-.374.083-1.166 1.292-1.082 2.208.083.917 2 .625 2.25 1s-.86 3.438-.417 3.75c1.125.792 2.333-1.541 2.583-2.25.118-.334.448-.804.764-1.21C12.698 10.596 10.126 13 7 13z" })));
    },
};
exports.default = Globe;
